module.exports = __webpack_public_path__ + "img/white_paper7.04665572.png";